import Curriculo, { FinderCurriculos, RetornoCurriculo } from 'Interface/Curriculos';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'Curriculos';

const url = '/curriculos';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarCurriculos: construtor.query<FinderCurriculos, Parametros | void>({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.curriculos
            ? [
                ...resultado.curriculos.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarCurriculo: construtor.query<
        RetornoCurriculo,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarCurriculo: construtor.mutation<Curriculo, Partial<Curriculo>>({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarCurriculo: construtor.mutation<
        Curriculo,
        Partial<Curriculo> & Pick<Curriculo, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerCurriculo: construtor.mutation<
        Curriculo,
        Partial<Curriculo> & Pick<Curriculo, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'DELETE'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarCurriculosQuery,
  useRecuperarCurriculoQuery,
  useAdicionarCurriculoMutation,
  useEditarCurriculoMutation,
  useRemoverCurriculoMutation,
} = apiExtendida;
